import { endpoints } from '../constants/endpoints';
import { sendRequest } from './sendRequest';

export const getSurveyDetailsApi = ({ surveyId }) => {
  const url = endpoints.engagement.survey;
  return sendRequest({
    url,
    credentials: 'include',
    queryParams: { survey_id: surveyId },
  });
};

export const updateSurveyApi = ({ surveyId, surveyQuestionId, selectedOptionId, feedbackText }) => {
  const url = endpoints.engagement.survey;
  return sendRequest({
    url,
    method: 'PUT',
    credentials: 'include',
    queryParams: { survey_id: surveyId },
    body: {
      id: surveyQuestionId,
      selectedAnswerOptions: selectedOptionId === null ? [] : [{ id: selectedOptionId }],
      feedbackText,
    },
  });
};

export const updateShortSurveyApi = ({ surveyId, surveyQuestionId, selectedOptionId, feedbackText }) => {
  const url = endpoints.nudge.shortSurvey;
  return sendRequest({
    url,
    method: 'POST',
    credentials: 'include',
    queryParams: { survey_id: surveyId },
    body: {
      id: surveyQuestionId,
      selectedAnswerOptions: selectedOptionId === null ? [] : [{ id: selectedOptionId }],
      feedbackText,
    },
  });
};

export const submitSurveyApi = ({ surveyId }) => {
  const url = endpoints.engagement.submitSurvey;
  return sendRequest({
    url,
    method: 'POST',
    credentials: 'include',
    queryParams: { survey_id: surveyId },
  });
};

export const activeSurveysApi = ({ offset, limit }) => {
  const url = endpoints.engagement.activeSurveys;
  return sendRequest({
    url,
    credentials: 'include',
    queryParams: { offset, limit, include_count: true },
  });
};

export const archivedSurveysApi = ({ offset, limit }) => {
  const url = endpoints.engagement.archivedSurveys;
  return sendRequest({
    url,
    credentials: 'include',
    queryParams: { offset, limit, include_count: true },
  });
};

export const surveyResultApi = ({ surveyId }) => {
  const url = endpoints.engagement.surveyResult;
  return sendRequest({
    url,
    credentials: 'include',
    queryParams: { survey_id: surveyId },
  });
};

export const shareExperienceApi = ({ sharedWith, isAnonymous, experiencePost }) => {
  const url = endpoints.engagement.shareExperience;
  return sendRequest({
    url,
    method: 'POST',
    credentials: 'include',
    body: {
      sharedWith,
      isAnonymous,
      experiencePost,
    },
  });
};

export const getSharedExperienceApi = ({ experienceId }) => {
  const url = endpoints.engagement.getSharedExperience;
  return sendRequest({
    url,
    credentials: 'include',
    queryParams: { experience_id: experienceId },
  });
};

export const getSharedExperienceListApi = () => {
  const url = endpoints.engagement.sharedExperienceList;
  return sendRequest({
    url,
    credentials: 'include',
  });
};

// survey kickstart apis

export const getKickstartSurveyListApi = () => {
  const url = endpoints.engagement.kickstart.index;
  return sendRequest({
    url,
    credentials: 'include',
  });
};

export const createSurveyApi = ({ body }) => {
  const url = endpoints.engagement.createSurvey;
  return sendRequest({
    method: 'POST',
    url,
    body,
    credentials: 'include',
  });
};

export const getSurveyApi = ({ surveyId }) => {
  const url = endpoints.engagement.getSurvey;
  return sendRequest({
    url,
    credentials: 'include',
    queryParams: { surveyId },
  });
};

export const updateSurveyKickStartApi = ({ body }) => {
  const url = endpoints.engagement.getSurvey;
  return sendRequest({
    method: 'PUT',
    url,
    credentials: 'include',
    body,
  });
};

export const getDriversApi = () => {
  const url = endpoints.engagement.drivers;
  return sendRequest({
    url,
    credentials: 'include',
    queryParams: { tagType: 'ENGAGEMENT_DRIVER', teamId: '-1' },
  });
};

export const getTemplateListApi = ({ includeSample = false }) => {
  const url = endpoints.engagement.surveyTemplateList;
  return sendRequest({
    url,
    credentials: 'include',
    queryParams: {
      include_sample: includeSample,
    },
  });
};

export const getSelectedTemplateApi = ({ surveyId }) => {
  const url = endpoints.engagement.selectedTemplate;
  return sendRequest({
    url,
    credentials: 'include',
    queryParams: { surveyId },
  });
};

export const setTemplateApi = ({ surveyId, templateId }) => {
  const url = endpoints.engagement.selectedTemplate;
  return sendRequest({
    method: 'PUT',
    url,
    credentials: 'include',
    queryParams: { surveyId, templateId },
  });
};

export const getSettingsApi = ({ surveyId }) => {
  const url = endpoints.engagement.settings;
  return sendRequest({
    url,
    credentials: 'include',
    queryParams: { surveyId },
  });
};

export const setSettingsApi = ({ surveyId, body }) => {
  const url = endpoints.engagement.settings;
  return sendRequest({
    method: 'PUT',
    url,
    body,
    credentials: 'include',
    queryParams: { surveyId },
  });
};

export const getRemindersApi = ({ surveyId }) => {
  const url = endpoints.engagement.reminders;
  return sendRequest({
    url,
    credentials: 'include',
    queryParams: { surveyId },
  });
};

export const saveRemindersApi = ({ surveyId, body }) => {
  const url = endpoints.engagement.reminders;
  return sendRequest({
    method: 'PUT',
    url,
    body,
    credentials: 'include',
    queryParams: { surveyId },
  });
};

export const getSurveyValidationApi = ({ surveyId }) => {
  const url = endpoints.engagement.validation;
  return sendRequest({
    url,
    credentials: 'include',
    queryParams: { surveyId },
  });
};

export const startSurveyApi = ({ surveyId }) => {
  const url = endpoints.engagement.startSurvey;
  return sendRequest({
    method: 'POST',
    url,
    credentials: 'include',
    queryParams: { surveyId },
  });
};

export const uploadEmployeesCSVApi = ({ fileObject, surveyId }) => {
  const url = endpoints.engagement.kickstart.cohortSelection.uploadEmployeesCSV;
  const data = new FormData();
  data.append('file', fileObject);
  return sendRequest({
    url,
    method: 'PUT',
    credentials: 'include',
    body: data,
    isMultiPart: true,
    queryParams: {
      surveyId,
    },
  });
};

export const getParticipantsApi = ({ surveyId }) => {
  const url = endpoints.engagement.kickstart.cohortSelection.getCohortV1;
  return sendRequest({
    url,
    method: 'GET',
    credentials: 'include',
    queryParams: {
      surveyId,
    },
  });
};

export const putParticipantsCohortApi = ({ surveyId, cohortId }) => {
  const url = endpoints.engagement.kickstart.cohortSelection.putCohort;
  return sendRequest({
    url,
    method: 'PUT',
    credentials: 'include',
    queryParams: {
      surveyId,
      cohort_id: cohortId,
    },
  });
};
